import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const LayoutNull = lazy(() => import('../../LayoutNull'))
const Login = lazy(() => import('../../pages/Login'))
const NewPassword = lazy(() => import('../../pages/NewPassword'))
const ExternalLinkSale = lazy(() => import('../../pages/ExternalLinkSale'))
const DigitalAccount = lazy(() => import('../../pages/DigitalAccount'))
const PrivacyPolice = lazy(() => import('../../pages/PrivacyPolice'))

function PublicRoutes() {
  return (
    <LayoutNull>
      <Suspense fallback={null}>
        <Switch>
          <Route exact path='/login' component={Login} />
          <Route exact path='/nova-senha/:token' component={NewPassword} />

          <Route exact path='/exn/venda-por-link-externo/:token' component={ExternalLinkSale}/>
          <Route exact path='/external/onboarding/conta-digital' component={DigitalAccount} />
          <Route exact path='/politicas/privacidade' component={PrivacyPolice} />
          <Redirect to='/login' />
        </Switch>
      </Suspense>
    </LayoutNull>
  )
}

export default PublicRoutes
